/*
  Памятка шага «Домовая книга»: где взять файл и как он должен выглядеть.

  Вынесена из `ResidentsUpload` 20.10.2026, когда шаг перешёл на путь «файл
  один раз» и упёрся в норму компонента (250 строк). Граница естественная:
  памятка - неизменный текст и образец, шаг - состояние и запросы. Текст
  перенесён дословно.
*/

import UploadHelp from './UploadHelp.jsx'

/* Образец - он же картинка над кнопкой «Скачать образец». Строки взяты из
   бланка домовой книги заказчика (л/с 20346), поэтому человек видит не
   выдуманный вид, а тот самый, который получится у него. */
const SAMPLE = {
  file: 'зарегистрированные-образец.csv',
  headers: ['Лицевой счёт', 'Ф.И.О.', 'Дата рождения', 'Дата прибытия', 'Дата выбытия', 'Родственные отношения'],
  rows: [
    ['20346', 'Веселков Александр Александрович', '08.09.2008', '01.03.2019', '', 'сын'],
    ['20346', 'Веселкова Ольга Петровна', '14.02.1981', '01.03.2019', '', 'мать'],
  ],
}

export default function ResidentsHelp() {
  return (
    <UploadHelp
      title="Где это взять и как должен выглядеть файл"
      where={[
        'В 1С это сведения о зарегистрированных по лицевому счёту - тот же список, ' +
          'который печатается в выписке из домовой книги: строка на каждого жильца.',
        'Один лицевой счёт встречается в файле столько раз, сколько человек в помещении ' +
          'зарегистрировано, - это нормально и ошибкой не считается.',
        'Таблицы нет и управляющая компания отдаёт только бланк - пришлите его сканом или ' +
          'фотографией (PDF, JPG, PNG, можно много страниц одним файлом): Арбитр ЖКХ ' +
          'вычитает жильцов сам и покажет каждую страницу на сверку рядом с картинкой.',
      ]}
      sample={SAMPLE}
      note={
        'Обязательны лицевой счёт и Ф.И.О. Остальное необязательно: чего нет в файле, ' +
        'то в выписке встанет прочерком. Присылайте выгрузку по ' +
        'счёту полностью, а не только изменения. Сведения, внесённые руками на карточке ' +
        'счёта, файл не трогает. Счета, по которым состав приходит обменом с 1С, ' +
        'пропускаются: ночной срез полнее файла, и два списка жильцов в одной выписке ' +
        'пришлось бы объяснять судье.'
      }
    />
  )
}
